import { withTranslation } from "react-i18next";

import React from 'react';
import { Footer } from '../Common/Footer';
import { AffiliatorSidebar } from '../Common/AffiliatorSidebar';
import { AffiliatorDashboardHeader } from '../Common/AffiliatorDashboardHeader';
import { Link } from 'react-router-dom'
import { Header } from '../Common';
import AffiliatorLinks from '../../Models/AffiliatorLinks';
import ReactTooltip from 'react-tooltip'
import Affiliator from '../../Models/Affiliator';
import Common from "../../Models/Common";
class AffiliatorDashboard extends React.Component {
    constructor(props) {
        super(props);
        let x = JSON.parse(localStorage.getItem('info'))
        if (x === null || x === '' || x.user_type_id !== 3) {
            alert(this.props.t('10'))
            this.props.history.push('/login/affiliator');
        };
        this.state = {
            _id: false,
            requitmentBonus: '',
            rankingBonus: '',
            lotteryBonus: '',
            total: '',
            totalProducts: '',
            universalLink: '',
            link: '',
            newusers: '',
            activeusers: '',
            rbonusstatus: '',
            luckyeli: ''
        };
        this.getDashboardBonus();
        this.getDashboardDirectBounus();
        this.getEligibilityStat();
    }
    componentDidMount() {
        let x = JSON.parse(localStorage.getItem('info'))
        window.scrollTo(0, 0)
        AffiliatorLinks.getRefLink(x.id).then(res => {
            if (res.data.link != null) {
                this.setState({ link: res.data.link, universalLink: res.data.universal_link })
            }
        })
    }
    getEligibilityStat() {
        let x = JSON.parse(localStorage.getItem('info'))
        Affiliator.getEligibilityStat(x.id).then(res => {
            console.log(res.data)
            this.setState({
                newusers: res.data.newuser,
                activeusers: res.data.activeusers,
                rbonusstatus: res.data.current_status,
                luckyeli: res.data.lucky_eli
            })
            console.log(this.state.luckyeli)
        })
    }
    getDashboardBonus() {
        let x = JSON.parse(localStorage.getItem('info'))
        Affiliator.getDashboardBonus(x.id).then(res => {
            console.log(res.data)
            this.setState({ requitmentBonus: res.data.rec_bonus, rankingBonus: res.data.rank_bonus, lotteryBonus: res.data.lottery_bonus, })
        })
    }
    getDashboardDirectBounus() {
        if (localStorage.getItem('info') !== null) {
            let x = JSON.parse(localStorage.getItem('info'))
            Affiliator.getDashboardDirectBonus(x.id).then(res => {
                console.log(res.data)
                this.setState({ total: parseInt(res.data.total) })
            })
            AffiliatorLinks.getTotalProducts(x.id).then(res => {
                console.log(res.data)
                this.setState({ totalProducts: res.data.total })
            })
        }
    }
    render() {
        console.log(this.state.universalLink)
        let l = this.state.universalLink.split('/')
        let allLink = l[l.length - 1]
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        if (isMobile) {
            return (
                <div className="wrapper">
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid main">
                        <div className="">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className=" mb-1 input_name big_font guide_text" style={{ width: '100%', fontSize: "20px" }}>
                                        <strong>{this.props.t('24')}</strong>
                                    </div>
                                    <div className="aff-dashboard-eligibilitybar dashboard-shadow row mr-0 ml-0" style={{ height: "auto" }}>
                                        <Link to={'/new-childern-thismonth'} className="col-4 text-center" style={{ textDecoration: 'none', color: '#888' }}>
                                            <div><span className="" style={{ color: "gray" }}>{this.props.t('32')}: {this.state.newusers}{this.props.t('34')}</span> </div>
                                        </Link>
                                        <Link to={'/active-childern-thismonth'} className="col-4 text-center" style={{ textDecoration: 'none', color: '#888' }}>
                                            <div><span className="" style={{ color: "gray" }}>{this.props.t('26')}: {this.state.activeusers}{this.props.t('34')}</span> </div>
                                        </Link>
                                        <div className="col-4 text-center"><span className="" style={{ color: "gray" }}>{this.props.t('30')}: {this.state.rbonusstatus}</span> </div>
                                    </div>
                                    <div className="aff-dashboard-eligibilitybar dashboard-shadow row mr-0 ml-0" style={{ height: "auto" }}>
                                        {(() => {
                                            if (this.state.luckyeli === 0) {
                                                return (
                                                    <div className="col-12 text-center row">
                                                        <div className="col-6 text-center"><span style={{ color: "gray" }}>{this.props.t('16')}</span></div>
                                                        <div className="col-6 text-center"><span style={{ color: "red", fontSize: "11px" }}>{this.props.t('0')}</span></div>
                                                    </div>
                                                )
                                            } else if (this.state.luckyeli === 1) {
                                                return (
                                                    <div className="col-12 text-center row">
                                                        <div className="col-6 text-center"><span style={{ color: "gray" }}>{this.props.t('16')}</span></div>
                                                        <div className="col-6 text-center"><span style={{ color: "green", fontSize: "11px" }}>{this.props.t('2')}</span></div>
                                                    </div>
                                                )
                                            }
                                        })()}
                                    </div>
                                    <div className="">
                                        <Link to={'/affiliator-individual-products'} className="" style={{ textDecoration: 'none', color: '#888' }}>
                                            <div className="summary text-center dashboard-shadow" style={{ borderRadius: '5px' }}>
                                                <div>{this.props.t('8')}</div>
                                                <div>{this.state.totalProducts}</div>
                                            </div>
                                        </Link>
                                        <Link to={'/affiliator-sales-management'} className="col" style={{ textDecoration: 'none', color: '#888' }}>
                                            <div className="summary text-center dashboard-shadow" style={{ borderRadius: '5px' }}>
                                                <div>{this.props.t('11')}</div>
                                                <div>{this.state.total} {this.props.t('36')}</div>
                                            </div>
                                        </Link>
                                        <Link to={'/aff-reqcuitment-bonus'} className="col-md-4" style={{ textDecoration: 'none', color: '#888' }}>
                                            <div className="summary text-center dashboard-shadow" style={{ borderRadius: '5px' }}>
                                                <div>{this.props.t('6')}</div>
                                                <div>{this.state.requitmentBonus} {this.props.t('36')}</div>
                                            </div>
                                        </Link>
                                        <Link to={'/aff-ranking-bonus'} className="col-md-4" style={{ textDecoration: 'none', color: '#888' }}>
                                            <div className="summary text-center dashboard-shadow" style={{ borderRadius: '5px' }}>
                                                <div>{this.props.t('12')}</div>
                                                <div>{this.state.rankingBonus} {this.props.t('36')}</div>
                                            </div>
                                        </Link>
                                        {/* <div className="dashboard-shadow">
                                            <Link to={'/aff-lottery-bonus'} style={{ textDecoration: 'none', color: '#888' }} >
                                                <div className="summary text-center" style={{ borderRadius: '5px' }} data-tip data-for='sadace'>
                                                    <div>{this.props.t('16')}</div>

                                                </div>
                                            </Link>
                                            <ReactTooltip id='sadace' type='warning' place='bottom' effect='float'>
                                                <span>{this.props.t('3')} </span>
                                            </ReactTooltip>
                                        </div> */}
                                    </div>
                                    <div className="mt-5 mb-1  input_name pages_headers" style={{ width: '100%', textAlign: 'left' }}> {this.props.t('19')}</div>
                                    <div className="">
                                        <p type="text" className="affiliator-links">{Common.domain_name}aff/{allLink}</p>
                                    </div>

                                    {/* <div className="mail_box">
                                        <div className="col-md-12 tr_blank_medium mt-2 pt-2"></div>
                                        <input type="text" className="mail_box_input" placeholder=" <a href={this.state.link} > 1{this.props.t('13')} </a > " />
                                        <span>{this.state.link}</span>
                                    </div> */}
                                    <div className="mt-5 mb-1 input_name  pages_headers" style={{ width: '100%', textAlign: 'left' }}> {this.props.t('27')}</div>
                                    <div className="">
                                        <div className="">
                                            <p type="text" className="affiliator-links">{Common.domain_name}{this.state.link}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div >
            )
        } else {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4 input_name">
                                        <AffiliatorSidebar />
                                    </div>
                                    <div className="col-md-8 ">
                                        <div className=" mb-3 input_name big_font guide_text" style={{ width: '100%' }}>
                                            <strong>{this.props.t('24')}</strong>
                                        </div>
                                        <div className="aff-dashboard-eligibilitybar dashboard-shadow row mr-0 ml-0">
                                            <Link to={'/new-childern-thismonth'} className="col-4 text-center" style={{ textDecoration: 'none', color: '#888' }}>
                                                <div><span className="" style={{ color: "gray" }}>{this.props.t('32')}: {this.state.newusers}{this.props.t('34')}</span> </div>
                                            </Link>
                                            <Link to={'/active-childern-thismonth'} className="col-4 text-center" style={{ textDecoration: 'none', color: '#888' }}>
                                                <div><span className="" style={{ color: "gray" }}>{this.props.t('26')}: {this.state.activeusers}{this.props.t('34')}</span> </div>
                                            </Link>
                                            <div className="col-4 text-center"><span className="" style={{ color: "gray" }}>{this.props.t('30')}: {this.state.rbonusstatus}</span> </div>
                                        </div>
                                        <div className="aff-dashboard-eligibilitybar dashboard-shadow row mr-0 ml-0">
                                            {(() => {
                                                if (this.state.luckyeli === 0) {
                                                    return (
                                                        <div className="col-12 text-center row">
                                                            <div className="col-6 text-center"><span style={{ color: "gray" }}>{this.props.t('16')}</span></div>
                                                            <div className="col-6 text-center"><span style={{ color: "red", fontSize: "11px" }}>{this.props.t('0')}</span></div>
                                                        </div>
                                                    )
                                                } else if (this.state.luckyeli === 1) {
                                                    return (
                                                        <div className="col-12 text-center row">
                                                            <div className="col-6 text-center"><span style={{ color: "gray" }}>{this.props.t('16')}</span></div>
                                                            <div className="col-6 text-center"><span style={{ color: "green", fontSize: "11px" }}>{this.props.t('2')}</span></div>
                                                        </div>
                                                    )
                                                }
                                            })()}
                                        </div>
                                        <div className="row">
                                            <Link to={'/affiliator-individual-products'} className="col-md-6" style={{ textDecoration: 'none', color: '#888' }}>
                                                <div className="summary text-center dashboard-shadow" style={{ borderRadius: '5px' }}>
                                                    <div>{this.props.t('8')}</div>
                                                    <div>{this.state.totalProducts}</div>
                                                </div>
                                            </Link>
                                            <Link to={'/affiliator-sales-management'} className="col-md-6" style={{ textDecoration: 'none', color: '#888' }}>
                                                <div className="summary text-center dashboard-shadow" style={{ borderRadius: '5px' }}>
                                                    <div>{this.props.t('11')}</div>
                                                    <div>{this.state.total} {this.props.t('36')}</div>
                                                </div>
                                            </Link>
                                        </div>
                                        <div className="row mt-3">
                                            <Link to={'/aff-reqcuitment-bonus'} className="col-md-6" style={{ textDecoration: 'none', color: '#888' }}>
                                                <div className="summary text-center dashboard-shadow" style={{ borderRadius: '5px' }}>
                                                    <div>{this.props.t('6')}</div>
                                                    <div>{this.state.requitmentBonus} {this.props.t('36')}</div>
                                                </div>
                                            </Link>
                                            <Link to={'/aff-ranking-bonus'} className="col-md-6" style={{ textDecoration: 'none', color: '#888' }}>
                                                <div className="summary text-center dashboard-shadow" style={{ borderRadius: '5px' }}>
                                                    <div>{this.props.t('12')}</div>
                                                    <div>{this.state.rankingBonus} {this.props.t('36')}</div>
                                                </div>
                                            </Link>
                                            {/* <div className="col-md-4">
                                                <Link to={'/aff-lottery-bonus'} style={{ textDecoration: 'none', color: '#888' }} >
                                                    <div className="summary text-center dashboard-shadow" style={{ borderRadius: '5px' }} data-tip data-for='sadace'>
                                                        <div>{this.props.t('16')}</div>

                                                    </div>
                                                </Link>

                                                <ReactTooltip id='sadace' type='warning' place='bottom' effect='float'>
                                                    <span>{this.props.t('2')}</span>
                                                </ReactTooltip>

                                            </div> */}
                                        </div>
                                        <div className="mt-5 mb-1 input_name big_font " style={{ width: '100%', textAlign: 'left' }}> {this.props.t('19')}</div>
                                        <div className="all_services_link dashboard-shadow">
                                            <div className="card">
                                                <div type="text" className=" card-title" style={{fontSize: '15px',padding:'7px 0px',marginBottom:'0px'}}>{Common.domain_name}aff/{allLink}</div>
                                            </div>
                                        </div>

                                        <div className="mt-5 mb-1  input_name big_font " style={{ width: '100%', textAlign: 'left' }}> {this.props.t('27')}</div>
                                        <div className="all_services_link dashboard-shadow">
                                            <div className="card">
                                                <div type="text" className=" card-title" style={{ fontSize: '15px',padding:'7px 0px',marginBottom:'0px' }}>{Common.domain_name}{this.state.link}</div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div >
                    <Footer />
                </div >
            )
        }

    }
}
export { AffiliatorDashboard }


 AffiliatorDashboard = withTranslation('src_Components_Dashboard_AffiliatorDashboard')(AffiliatorDashboard);
